import { computed, toValue } from 'vue';
import { PAYMENT_PROVIDERS } from 'Dictionaries/quickpay/paymentProvidersDictionary';
import Feature from 'Services/Feature';

const CONNECTED_BONUS = 6;
const ACTIVE_STATUSES = ['connected', 'error'];

export function usePaymentProviders(providerStatuses = {}, $t) {
    const sortedProviders = computed(() => {
        const statuses = toValue(providerStatuses);
        return Object.values(PAYMENT_PROVIDERS)
            .filter((provider) => {
                if (provider.featureFlag && !Feature.isEnabled(provider.featureFlag)) {
                    return false;
                }
                return true;
            })
            .map((provider) => {
                const status = statuses[provider.id] ?? 'disabled';
                const isConnected = ACTIVE_STATUSES.includes(status);
                const hasError = status === 'error';
                const score = provider.baseScore + (isConnected ? CONNECTED_BONUS : 0);
                const description = provider.descriptionKey
                    ? $t.__(provider.descriptionKey)
                    : '';
                return { ...provider, description, status, isConnected, hasError, score };
            })
            .sort((a, b) => b.score - a.score);
    });

    return { sortedProviders };
}
